const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,

  

  PATIENT: {
    LOGIN: "/patient/login",
    REGISTER: "/patient/register",
    COMPLETE_PROFILE: "/patient/complete-profile",
    PROFILE: "/patient/profile",
    PROFILE_PICTURE: "/patient/profile-picture"
  }

};

export default config;
